import { EmbedVideoPayload } from '~/common/types/types';

const embedVideoPayload: EmbedVideoPayload = {
  title: 'past.title',
  videoSrc: 'https://www.youtube.com/embed/zuvftWKXuXI',
};

export { embedVideoPayload };
